module.exports = __webpack_public_path__ + "img/arrow.a482f942.svg";